import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { AlertasService } from 'src/app/core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CoreService } from '../core/_services/core.services';

@Component({
  selector: 'app-procesos-contratacion',
  templateUrl: './procesos-contratacion.component.html',
  styleUrls: ['./procesos-contratacion.component.scss']
})
export class ProcesosContratacionComponent implements OnInit {

  columnas: any[] = [];
  totalRecords = 0;
  registros: any[] = [];
  formBuilder: FormBuilder;
  formularioFiltro: FormGroup;
  cargandoListaConsultas: boolean = true;
  buscar: boolean = false;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService
  ) { 
    this.formBuilder = new FormBuilder();
  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'requerimiento_id', header: 'Requerimiento' },
      { field: 'numero_id', header: 'Documento' },
      { field: 'descripcion', header: 'Estado Actual' },
    ];

    this.formularioFiltro = this.formBuilder.group({
      cedula: [''],
    })
  }

  getListado() {
    
    let params = {
      cedula: this.formularioFiltro.value.cedula,
    }
    if (params.cedula == '') {
      this.buscar = false;
    } else {
      this.coreService.getWithParams('/proceso-contratacion', params).subscribe(
        (res: any[]) => {
          this.buscar = true;
          this.registros = res;
          this.totalRecords = res.length;
        },
        (err: any) => {
          console.log(err);
        }
      )
    }
  }

}
